module.exports = __webpack_public_path__ + "img/contact-zalo.aba10086.png";